import { EnabledDisabledStatus, ProductCategoryType } from "./CategoriesContainer.reducer";

export const SET_FILTER_STATE = "SET_FILTER_STATE";

export function setSubcategoryFilterState(MainCategoryFilter: ProductCategoryType[], SubcategoryStatusEnabled: EnabledDisabledStatus[]) {
    return {
        type: SET_FILTER_STATE,
        payload: { MainCategoryFilter, SubcategoryStatusEnabled }
    };
}

